export default "__VITE_ASSET__Cbg9VqnJ__"